const PEDIDOS_DE_RESPUESTA = {
  "gfcfuentes2@gmail.com": "contanos dónde conociste FORJA y cómo llegaste a Liga Geniun.",
  "mrincredible1067bjej@gmail.com": "contanos si estás organizando una liga real o si estás probando FORJA.",
} as const;

export function tieneRespuestaPendiente(email: string): boolean {
  return Object.hasOwn(PEDIDOS_DE_RESPUESTA, email.trim().toLowerCase());
}

export function textoRespuestaPendiente(email: string): string {
  return PEDIDOS_DE_RESPUESTA[email.trim().toLowerCase() as keyof typeof PEDIDOS_DE_RESPUESTA]
    ?? "contanos un poco más sobre tu liga.";
}
